export default __webpack_public_path__ + "static/media/service.a00aa8e7.jpg";